/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterDeviceAddPost } from '../fn/device/api-master-device-add-post';
import { ApiMasterDeviceAddPost$Params } from '../fn/device/api-master-device-add-post';
import { apiMasterDeviceDeleteGet } from '../fn/device/api-master-device-delete-get';
import { ApiMasterDeviceDeleteGet$Params } from '../fn/device/api-master-device-delete-get';
import { apiMasterDeviceEditPost } from '../fn/device/api-master-device-edit-post';
import { ApiMasterDeviceEditPost$Params } from '../fn/device/api-master-device-edit-post';
import { apiMasterDeviceGetActiveGet } from '../fn/device/api-master-device-get-active-get';
import { ApiMasterDeviceGetActiveGet$Params } from '../fn/device/api-master-device-get-active-get';
import { apiMasterDeviceGetAllGet } from '../fn/device/api-master-device-get-all-get';
import { ApiMasterDeviceGetAllGet$Params } from '../fn/device/api-master-device-get-all-get';
import { apiMasterDeviceGetByCriteriaPost } from '../fn/device/api-master-device-get-by-criteria-post';
import { ApiMasterDeviceGetByCriteriaPost$Params } from '../fn/device/api-master-device-get-by-criteria-post';
import { Device } from '../models/device';
import { DeviceApiRespModel } from '../models/device-api-resp-model';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';

@Injectable({ providedIn: 'root' })
export class DeviceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterDeviceAddPost()` */
  static readonly ApiMasterDeviceAddPostPath = '/api/Master/Device/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDeviceAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDeviceAddPost$Response(params?: ApiMasterDeviceAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceApiRespModel>> {
    return apiMasterDeviceAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDeviceAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDeviceAddPost(params?: ApiMasterDeviceAddPost$Params, context?: HttpContext): Observable<DeviceApiRespModel> {
    return this.apiMasterDeviceAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceApiRespModel>): DeviceApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterDeviceEditPost()` */
  static readonly ApiMasterDeviceEditPostPath = '/api/Master/Device/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDeviceEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDeviceEditPost$Response(params?: ApiMasterDeviceEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceApiRespModel>> {
    return apiMasterDeviceEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDeviceEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDeviceEditPost(params?: ApiMasterDeviceEditPost$Params, context?: HttpContext): Observable<DeviceApiRespModel> {
    return this.apiMasterDeviceEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceApiRespModel>): DeviceApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterDeviceDeleteGet()` */
  static readonly ApiMasterDeviceDeleteGetPath = '/api/Master/Device/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDeviceDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDeviceDeleteGet$Response(params?: ApiMasterDeviceDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterDeviceDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDeviceDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDeviceDeleteGet(params?: ApiMasterDeviceDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterDeviceDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterDeviceGetAllGet()` */
  static readonly ApiMasterDeviceGetAllGetPath = '/api/Master/Device/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDeviceGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDeviceGetAllGet$Response(params?: ApiMasterDeviceGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Device>>> {
    return apiMasterDeviceGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDeviceGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDeviceGetAllGet(params?: ApiMasterDeviceGetAllGet$Params, context?: HttpContext): Observable<Array<Device>> {
    return this.apiMasterDeviceGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Device>>): Array<Device> => r.body)
    );
  }

  /** Path part for operation `apiMasterDeviceGetActiveGet()` */
  static readonly ApiMasterDeviceGetActiveGetPath = '/api/Master/Device/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDeviceGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDeviceGetActiveGet$Response(params?: ApiMasterDeviceGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Device>>> {
    return apiMasterDeviceGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDeviceGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterDeviceGetActiveGet(params?: ApiMasterDeviceGetActiveGet$Params, context?: HttpContext): Observable<Array<Device>> {
    return this.apiMasterDeviceGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Device>>): Array<Device> => r.body)
    );
  }

  /** Path part for operation `apiMasterDeviceGetByCriteriaPost()` */
  static readonly ApiMasterDeviceGetByCriteriaPostPath = '/api/Master/Device/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterDeviceGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDeviceGetByCriteriaPost$Response(params?: ApiMasterDeviceGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Device>>> {
    return apiMasterDeviceGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterDeviceGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterDeviceGetByCriteriaPost(params?: ApiMasterDeviceGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Device>> {
    return this.apiMasterDeviceGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Device>>): Array<Device> => r.body)
    );
  }

}
